import axios from "axios";

export const updateEmotionStatusApi = async (userId, status) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/emotionStatus/${userId}`, { status });
    return data.data
};
